import React, { FC } from "react";
import { Helmet } from "react-helmet";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";

export interface PageSellerGuidesProps {
  className?: string;
}

const BuyerGuides: FC<PageSellerGuidesProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-PageSellerGuides overflow-hidden relative ${className}`}
      data-nc-id="PageSellerGuides"
    >
      <Helmet>
        <title>Ръководство за купувачи - TryBuy.club</title>
      </Helmet>

      <BgGlassmorphism />

      <div className="container py-16 lg:py-28 space-y-16 lg:space-y-28">
        <div className="py-16 lg:py-28 space-y-8 lg:space-y-12">
          <h2 className="text-3xl lg:text-4xl font-semibold text-gray-900">
            Ръководство за купувачи
          </h2>

          <p>
            Добре дошли в TryBuy.club – водещата платформа за откриване на инвестиционни възможности
            в хотелски имоти по целия свят. Независимо дали сте опитен инвеститор или купувате за
            първи път, нашата платформа предлага прост, сигурен и ефективен начин да намерите и
            придобиете перфектния хотелски имот.
          </p>

          <h3 className="text-2xl lg:text-3xl font-semibold text-gray-900">
            Какво ще откриете при нас:
          </h3>

          <h4 className="text-xl lg:text-2xl font-semibold text-gray-900">
            Ексклузивни хотелски имоти:
          </h4>
          <p>
            Разгледайте селекция от висококачествени хотелски имоти, подбрани за инвестиции. Нашите
            обяви включват хотели на първокласни локации по света – от луксозни курорти до бутикови
            хотели – с висок потенциал за растеж и възвръщаемост.
          </p>

          <h4 className="text-xl lg:text-2xl font-semibold text-gray-900">
            Имотите са готови за инвестиция:
          </h4>
          <p>
            Всяка обява в TryBuy.club се преглежда внимателно, за да отговаря на нашите стандарти за
            качество и рентабилност. Фокусираме се върху имоти с доказани резултати и голям
            потенциал за бъдещ успех, така че да вземате информирани и уверени решения.
          </p>

          <h4 className="text-xl lg:text-2xl font-semibold text-gray-900">
            Широк спектър от локации:
          </h4>
          <p>
            Независимо дали търсите имоти в оживени центрове, живописни морски курорти или на
            нововъзникващи пазари, платформата ни предлага разнообразие от опции. Така ще намерите
            възможности на топ дестинации по света и ще диверсифицирате инвестиционното си
            портфолио.
          </p>

          <h3 className="text-2xl lg:text-3xl font-semibold text-gray-900">Как работи:</h3>

          <h4 className="text-xl lg:text-2xl font-semibold text-gray-900">
            Създайте безплатен акаунт:
          </h4>
          <p>
            За да получите достъп до TryBuy.club и да започнете да разглеждате имоти, просто си
            създайте безплатен акаунт. Това ви дава достъп до детайлни обяви и ексклузивни
            инвестиционни възможности.
          </p>

          <h4 className="text-xl lg:text-2xl font-semibold text-gray-900">
            Разглеждайте и търсете:
          </h4>
          <p>
            След регистрация можете да разглеждате нашите разнообразни обяви. Използвайте филтри по
            локация, ценови диапазон и инвестиционни критерии. С няколко клика ще намерите имоти,
            които съвпадат с вашите предпочитания.
          </p>

          <h4 className="text-xl lg:text-2xl font-semibold text-gray-900">Подробни обяви:</h4>
          <p>
            Всяка обява съдържа цялата ключова информация – детайли за хотела, инвестиционен
            потенциал и очаквана възвръщаемост. Ще намерите качествени снимки, финансови отчети и
            друга информация, за да оцените стойността на имота.
          </p>

          <h4 className="text-xl lg:text-2xl font-semibold text-gray-900">Резервирайте престой:</h4>
          <p>
            Знаем, че покупката на хотел е голямо решение. Затова предлагаме възможност да
            резервирате престой в имота, който ви интересува, преди да го купите. Така ще получите
            личен опит и сигурност, че отговаря на целите ви.
          </p>

          <h4 className="text-xl lg:text-2xl font-semibold text-gray-900">Изразете интерес:</h4>
          <p>
            Когато намерите подходящ имот, можете да подадете заявка за покупка директно през
            платформата. Системата ни е лесна за използване и улеснява комуникацията между вас и
            продавача.
          </p>

          <h4 className="text-xl lg:text-2xl font-semibold text-gray-900">
            Сигурна комуникация и транзакции:
          </h4>
          <p>
            Всички резервации и заявки за покупка минават през TryBuy.club, което гарантира
            прозрачност и сигурност. Плащанията за имота се извършват директно между вас и
            продавача, а платформата улеснява процеса по комуникация и резервация.
          </p>

          <h4 className="text-xl lg:text-2xl font-semibold text-gray-900">Експертна помощ:</h4>
          <p>
            Нашият екип е тук, за да ви съдейства на всяка стъпка – от избора на имоти и резервация
            до разбирането на целия процес по покупка. Получавате професионално съдействие за
            най-добро изживяване.
          </p>

          <h3 className="text-2xl lg:text-3xl font-semibold text-gray-900">
            Защо да купите чрез TryBuy.club?
          </h3>

          <h4 className="text-xl lg:text-2xl font-semibold text-gray-900">
            Лесен достъп до глобален пазар:
          </h4>
          <p>
            Нашата платформа ви свързва с широк спектър от имоти по света, давайки ви възможност да
            диверсифицирате своето портфолио.
          </p>

          <h4 className="text-xl lg:text-2xl font-semibold text-gray-900">
            Прозрачност и сигурност:
          </h4>
          <p>
            Ние поставяме прозрачността на първо място, като гарантираме сигурна и надеждна среда за
            закупуване на хотелски имоти.
          </p>

          <h4 className="text-xl lg:text-2xl font-semibold text-gray-900">
            Тествай преди да инвестираш:
          </h4>
          <p>
            Възможността да резервирате престой и да изживеете имота преди покупка ви дава
            допълнителна увереност.
          </p>

          <h4 className="text-xl lg:text-2xl font-semibold text-gray-900">Глобална подкрепа:</h4>
          <p>
            Нашият експертен екип е готов да ви съдейства при всяко инвестиционно решение,
            осигурявайки плавен и успешен процес от начало до край.
          </p>

          <h3 className="text-2xl lg:text-3xl font-semibold text-gray-900">
            Започнете своето инвестиционно пътешествие днес
          </h3>
          <p>
            Готови ли сте да откриете нови инвестиционни възможности? Създайте безплатен акаунт сега
            и започнете да намирате правилните хотелски имоти за вашето портфолио чрез TryBuy.club.
            Независимо дали това е първият ви хотел или разширявате вече съществуващи инвестиции –
            ние правим процеса лесен и сигурен.
          </p>
        </div>

        <div className="relative py-16">
          <BackgroundSection />
          <SectionClientSay uniqueClassName="PageSellerGuides_" />
        </div>

        <SectionSubscribe2 />
      </div>
    </div>
  );
};

export default BuyerGuides;
